import {
    Box,
    Stack,
    Heading,
    Text,
    SimpleGrid,
    Spinner,
    Center,
    Spacer,
    Divider
} from '@chakra-ui/react'
import ChildCard from './ChildCard'
import { useMyProfileAsParent } from '@/modules/parent/hooks/useMyProfileAsParent'
import RegisterChild from '../register-child-page'

export default function ChildListPage() {
    const { data: parentData, loading: parentDataLoading } = useMyProfileAsParent()

    // No early-return on a missing parent record: a user who isn't a parent yet
    // (e.g. a teacher who just had a child) should still see this page and the
    // "Add Children" button — adding the first child creates their parent record.

    return (
        <Box
            minH={['container.sm', 'container.md']}
            borderRadius={4}
            bg={'white'}
            mx={'auto'}
            pt={5}
            px={{ base: 2, md: 17 }}
        >
            <Box p={8}>
                <Stack direction={['column', 'row']} align={'center'}>
                    <Box>
                        <Heading
                            fontSize={{ base: '3xl', sm: '3xl' }}
                            fontWeight={'bold'}
                        >
                            List of Children
                        </Heading>
                        <Text
                            color={'gray.600'}
                            mb="4"
                            fontSize={{ base: 'sm', sm: 'lg' }}
                        >
                            You see the your child details and generate code for them
                        </Text>
                    </Box>
                    <Spacer />
                    <Box>
                        <RegisterChild />
                    </Box>
                </Stack>
                <Divider my={4} />

                {parentDataLoading ? (
                    <Center>
                        <Spinner size="xl" />
                    </Center>
                ) : (
                    <SimpleGrid
                        spacing={3}
                        templateColumns="repeat(auto-fill, minmax(300px, 1fr))"
                    >
                        {parentData.children.length > 0 ? (
                            parentData.children.map((child) => {
                                return (
                                    <ChildCard
                                        key={child._id}
                                        firstName={child.firstName}
                                        middleName={child.middleName}
                                        lastName={child.lastName}
                                        dateOfBirth={child.dateOfBirth}
                                        gender={child.gender}
                                        lastCheckinCode={child.lastCheckinCode}
                                        bloodGroup={child.bloodGroup}
                                        picture={child.picture}
                                        qrCode={child.qrCode}
                                        childId={child._id}
                                    />
                                )
                            })
                        ) : (
                            <Text>No child added yet.</Text>
                        )}
                    </SimpleGrid>
                )}
            </Box>
        </Box>
    )
}
